import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import store, { persistor } from './redux';
import './index.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth-config';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
	ReactDOM.createRoot(document.getElementById('root')).render(
		<MsalProvider instance={msalInstance}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<App />
				</PersistGate>
			</Provider>
		</MsalProvider>,
	);
});
